import { defineMessages } from 'react-intl';

export default defineMessages({
  answers: 'Odpowiedzi',
  see: 'Zobacz przypisane ankiety',
});
